import { Box, Skeleton } from '@mui/material';

export const MetricCardSkeleton = () => (
  <Box
    aria-hidden="true"
    data-testid="metric-card-skeleton"
    sx={{
      border: 1,
      borderColor: 'divider',
      borderRadius: 2,
      boxSizing: 'border-box',
      minWidth: 0,
      p: { xs: 2, sm: 2.5 },
      width: '100%',
    }}
  >
    <Skeleton variant="text" width="52%" />
    <Skeleton height={42} variant="text" width="72%" />
    <Skeleton variant="text" width="36%" />
  </Box>
);

export default MetricCardSkeleton;
